import { useTranslation } from 'react-i18next';

import { useTrialDiscount } from '@/hooks/user';
import Cancel from '@/icons/cancel.svg';
import CircleCheck from '@/icons/check-circle.svg';
import Fire from '@/icons/fire.svg';
import Redeem from '@/icons/redeem.svg';
import { isFeatureChecked } from '@/pages/Checkout/hooks';

function PlansFeatures({ plans, bestPlan }) {
	const { t } = useTranslation();

	const features = t('billing.features.table.items', { returnObjects: true });
	const trialDiscount = useTrialDiscount();
	const textBestPlanFlag = trialDiscount
		? t('billing.trialDiscountShort')
		: t('billing.mostPopular');

	return (
		<div className="mt-[4.25rem] flex w-full flex-col pb-[60px]">
			<h2 className="pb-12 font-title text-4xl font-semibold leading-[52px]">
				{t('billing.features.title')}
			</h2>

			<table className="mt-8 bg-white">
				<thead>
					<tr>
						{plans.map(plan => (
							<th
								className="relative inline-block w-[50%] border border-grey-200 p-4 text-center text-xs font-semibold md:text-base"
								key={plan.name}
							>
								{t(`plans.${plan.name}.name`)}
								{plan.handlerId === bestPlan.handlerId && (
									<div className="absolute left-0 top-[-2.51rem] h-10 w-full rounded-tl rounded-tr bg-red-background p-2 text-red">
										<span className="flex items-center justify-center gap-2 text-sm font-semibold">
											{trialDiscount ? <Redeem /> : <Fire />}
											{textBestPlanFlag}
										</span>
									</div>
								)}
							</th>
						))}
						<th className="block w-full border-x border-b border-grey-200 px-4 py-2 text-left text-xs font-semibold leading-7 md:text-base">
							{t('billing.features.table.title')}
						</th>
					</tr>
				</thead>

				<tbody>
					{features.map((feat, index) => (
						<tr className="block" key={`tr-feat-${index}`}>
							<th className="inline-block w-full border-x border-grey-200 px-4 py-[26px] text-left text-xs font-semibold leading-5 text-grey-500">
								{feat}
							</th>
							{plans.map((plan, ix) => (
								<td
									aria-label={
										isFeatureChecked(plan.name, index)
											? t('common.yes')
											: t('common.no')
									}
									className="inline-block w-[50%] border border-grey-200 p-2 text-center font-semibold text-grey-500"
									key={plan.name + ix}
								>
									{isFeatureChecked(plan.name, index) ? (
										<CircleCheck
											aria-hidden
											className="m-auto text-black"
										/>
									) : (
										<Cancel aria-hidden className="m-auto" />
									)}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

export default PlansFeatures;
